import CommonModal from './CommonModal';
import type { Props as CommonModalProps } from './CommonModal';

export default CommonModal;

export type { CommonModalProps };
